import React from 'react';
import { Select, message, Modal, Input, Radio, Checkbox, Col, Row, Icon } from 'antd';
import moment from 'moment'
import xlsx from 'better-xlsx';
import { saveAs } from 'file-saver';
import 'whatwg-fetch';
import request from './request'

const { info } = Modal;
let PopWindow;
const { File } = xlsx;
const SSAS = {

  /**dqid数组**/
  arrDqid: (objUser) => {
    let _dqid = objUser.dqid;
    let _arrDqid = [];
    if (_dqid.length >= 2) {
      _arrDqid.push(_dqid.substring(0, 2) + '0000');
    }
    if (_dqid.length >= 4) {
      _arrDqid.push(_dqid.substring(0, 4) + '00');
    }
    if (_dqid.length >= 6) {
      _arrDqid.push(_dqid.substring(0, 6));
    }
    if (_dqid.length >= 9) {
      _arrDqid.push(_dqid.substring(0, 9));
    }
    if (_dqid.length >= 12) {
      _arrDqid.push(_dqid.substring(0, 12));
    }
    return _arrDqid;
  },
  /**辖区dqid数组**/
  arrDqidXq: (objUser) => {
    let _dqid = objUser.dqid;
    let _czyjb = parseInt(objUser.czyjb);
    let _arrDqidXq = [];
    if (_dqid.length >= 2 && _czyjb >= 2) {
      _arrDqidXq.push(_dqid.substring(0, 2) + '0000');
    }
    if (_dqid.length >= 4 && _czyjb >= 3) {
      _arrDqidXq.push(_dqid.substring(0, 4) + '00');
    }
    if (_dqid.length >= 6 && _czyjb >= 4) {
      _arrDqidXq.push(_dqid.substring(0, 6));
    }
    if (_dqid.length >= 9 && _czyjb >= 5) {
      _arrDqidXq.push(_dqid.substring(0, 9));
    }
    if (_dqid.length >= 12 && _czyjb >= 6) {
      _arrDqidXq.push(_dqid.substring(0, 12));
    }
    return _arrDqidXq;
  },
  /**数据绑定**/
  /*Select 绑定数据字典*/
  SelectDataBind: (store, type, key) => {
    const Option = Select.Option;
    let dataSource = [];
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          dataSource = _sjzd[index].children;
        }
      });
    }
    else if (type === 'dm_xtgl_dwdm') {
      dataSource = store.Dictionaries.dm_xtgl_dwdm.list;
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_dw_rydm.list;
    }
    else if (type === 'dm_xtgl_ksdm') {
      dataSource = store.Dictionaries.dm_xtgl_ksdm.list;
    }
    else if (type === 'dm_xtgl_ks_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_ks_rydm.list;
    }
    else if (type === 'dm_xtgl_glmk') {
      dataSource = store.Dictionaries.dm_xtgl_glmk.list;
    }
    else if (type === 'init') {//store未传递的数据集


      dataSource = store;
    }
    return (
      dataSource.map((menu, index) => {
        return (<Option value={menu.value}>{menu.text}</Option>)
      })
    )
  },
  RadioGroupBind: (store, type, key) => {
    let dataSource = [];
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          dataSource = _sjzd[index].children.map(item => {
            return { value: item.value, label: item.value };
          });
        }
      });
    }
    else if (type === 'dm_xtgl_dwdm') {
      const _dwzd = store.Dictionaries.dm_xtgl_dwdm.list;
      _dwzd.map((item, index) => {
        return (<Radio value={item.value}>{item.text}</Radio>);
      });
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      const _ryzd = store.Dictionaries.dm_xtgl_dw_rydm.list;
      _ryzd.map((item, index) => {
        return (<Radio value={item.value}>{item.text}</Radio>);
      });
    }
    return dataSource;
  },
  RadioGroup: (store, type, key, span) => {
    let dataSource = [];
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          _sjzd[index].children.map(item => {
            dataSource.push({ value: item.value, label: item.value });
          })
        }

      });
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_dw_rydm.list;
    }
    return <Row>
      {
        dataSource.map(item => (<Col span={span || 4}><Radio value={item.value}>{item.label}</Radio></Col>))
      }
    </Row>
  },
  CheckBoxGroupBind: (store, type, key) => {
    let dataSource = [];
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          _sjzd[index].children.map(item => {
            dataSource.push({ value: item.value, label: item.value });
          })
        }

      });
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_dw_rydm.list;
    }
    return dataSource;
  },
  CheckBoxGroup: (store, type, key, span) => {
    let dataSource = [];
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          _sjzd[index].children.map(item => {
            dataSource.push({ value: item.value, label: item.value });
          })
        }

      });
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_dw_rydm.list;
    }
    return dataSource.map(item => (<Col span={span}><Checkbox value={item.value}>{item.label}</Checkbox></Col>))
  },
  ViewGroup: (store, type, key, value, number, border, noCheck) => {//在不影响原有方法的情况下，增加border,表示是否需要边框,增加 noCheck,处理字典需要依次显示且需要显示序号且不需要显示勾的情况
    let dataSource = [];
    if (value === '' || value === undefined || value === null) {
      value = 'NULL';
    }
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          _sjzd[index].children.map(item => {
            dataSource.push({ value: item.value, label: item.value });
          })
        }

      });
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_dw_rydm.list;
    }
    if (number) {
      return <Row>
        {dataSource.map((item, index) => (value.indexOf(item.value) > -1 || item.value.indexOf(value) > -1 ? <div style={{ paddingRight: '10px' }}><Col span={2} style={{ textAlign: 'right' }}>
          {
            border ? <span style={{ border: 'solid 1px #504e4e' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span> : <Icon type='check' style={{ fontSize: '12px' }}></Icon>
          }

        </Col>
          <Col span={22}>{(parseInt(index) + 1).toString() + ". "}{item.label}</Col></div> : <div style={{ paddingRight: '10px' }}><Col span={2}></Col><Col span={22}>{(parseInt(index) + 1).toString() + ". "}{item.label}</Col></div>))}
      </Row>
    }
    else {
      if (noCheck) {
        return dataSource.map((item, index) => (value.indexOf(item.value) > -1 || item.value.indexOf(value) > -1 ? <span style={{ paddingRight: '10px' }}>
          {
            border ? <span style={{ border: 'solid 1px #504e4e' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span> : null
          }
          {(parseInt(index) + 1).toString() + ". "}{item.label}</span> : <span style={{ paddingRight: '10px' }}>{(parseInt(index) + 1).toString() + ". "}{item.label}</span>))
      }
      else {
        return dataSource.map((item, index) => (value.indexOf(item.value) > -1 || item.value.indexOf(value) > -1 ? <span style={{ paddingRight: '10px' }}>
          {
            border ? <span style={{ border: 'solid 1px #504e4e' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span> : <Icon type='check' style={{ fontSize: '12px' }}></Icon>
          }
          {item.label}</span> : <span style={{ paddingRight: '10px' }}>{item.label}</span>))
      }
    }
  },
  ViewDataGroup: (dataSource, value, number, border) => {
    if (value === '' || value === undefined || value === null) {
      value = 'NULL';
    }
    if (number) {
      return <Row>
        {dataSource.map((item, index) => (value.indexOf(item.value) > -1 || item.value.indexOf(value) > -1 ? <div style={{ paddingRight: '10px' }}><Col span={2} style={{ textAlign: 'right' }}>
          {
            border ? <span style={{ border: 'solid 1px #504e4e' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span> : <Icon type='check' style={{ fontSize: '12px' }}></Icon>
          }
        </Col><Col span={22}>{(parseInt(index) + 1).toString() + ". "}{item.label}</Col></div> : <div style={{ paddingRight: '10px' }}><Col span={2}></Col><Col span={22}>{(parseInt(index) + 1).toString() + ". "}{item.label}</Col></div>))}
      </Row>
    }
    else {
      return dataSource.map((item, index) => (value.indexOf(item.value) > -1 || item.value.indexOf(value) > -1 ? <span style={{ paddingRight: '10px' }}>
        {
          border ? <span style={{ border: 'solid 1px #504e4e' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span> : <Icon type='check' style={{ fontSize: '12px' }}></Icon>
        }
        {item.label}</span> : <span style={{ paddingRight: '10px' }}>{item.label}</span>))
    }
  },
  ViewGroupBorder: (store, type, key, value, number, span) => {
    let dataSource = [];
    if (value === '' || value === undefined || value === null) {
      value = 'NULL';
    }
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          _sjzd[index].children.map(item => {
            dataSource.push({ value: item.value, label: item.value });
          })
        }

      });
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_dw_rydm.list;
    }
    if (number) {
      return <Row>
        {dataSource.map((item, index) => (value.indexOf(item.value) > -1 || item.value.indexOf(value) > -1 ?
          <Col span={span || 6}>
            <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span>&nbsp;<span>{(parseInt(index) + 1).toString() + ". "}{item.label}</span>
          </Col>
          :
          <Col span={span || 6}>
            <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px' }}>&nbsp;</span>&nbsp;<span>{(parseInt(index) + 1).toString() + ". "}{item.label}</span>
          </Col>
        )
        )}
      </Row>
    }
    else {
      return <Row>
        {dataSource.map((item, index) => (value.indexOf(item.value) > -1 || item.value.indexOf(value) > -1 ?
          <Col span={span || 6}>
            <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span>&nbsp;<span>{item.label}</span>
          </Col>
          :
          <Col span={span || 6}>
            <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px' }}>&nbsp;</span>&nbsp;<span>{item.label}</span>
          </Col>
        )
        )}
      </Row>
    }
  },

  ViewGroupEq: (store, type, key, value, number, border, noCheck) => {//在不影响原有方法的情况下，增加border,表示是否需要边框,增加 noCheck,处理字典需要依次显示且需要显示序号且不需要显示勾的情况
    let dataSource = [];
    if (value === '' || value === undefined || value === null) {
      value = 'NULL';
    }
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          _sjzd[index].children.map(item => {
            dataSource.push({ value: item.value, label: item.value });
          })
        }

      });
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_dw_rydm.list;
    }
    if (number) {
      return <Row>
        {dataSource.map((item, index) => (value === item.value ? <div style={{ paddingRight: '10px' }}><Col span={2} style={{ textAlign: 'right' }}>
          {
            border ? <span style={{ border: 'solid 1px #504e4e' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span> : <Icon type='check' style={{ fontSize: '12px' }}></Icon>
          }

        </Col>
          <Col span={22}>{(parseInt(index) + 1).toString() + ". "}{item.label}</Col></div> : <div style={{ paddingRight: '10px' }}><Col span={2}></Col><Col span={22}>{(parseInt(index) + 1).toString() + ". "}{item.label}</Col></div>))}
      </Row>
    }
    else {
      if (noCheck) {
        return dataSource.map((item, index) => (value === item.value ? <span style={{ paddingRight: '10px' }}>
          {
            border ? <span style={{ border: 'solid 1px #504e4e' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span> : null
          }
          {(parseInt(index) + 1).toString() + ". "}{item.label}</span> : <span style={{ paddingRight: '10px' }}>{(parseInt(index) + 1).toString() + ". "}{item.label}</span>))
      }
      else {
        return dataSource.map((item, index) => (value === item.value ? <span style={{ paddingRight: '10px' }}>
          {
            border ? <span style={{ border: 'solid 1px #504e4e' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span> : <Icon type='check' style={{ fontSize: '12px' }}></Icon>
          }
          {item.label}</span> : <span style={{ paddingRight: '10px' }}>{item.label}</span>))
      }
    }
  },
  ViewGroupBorderEq: (store, type, key, value, number, span) => {//值相等判断,不做相似度匹配
    let dataSource = [];
    if (value === '' || value === undefined || value === null) {
      value = 'NULL';
    }
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          _sjzd[index].children.map(item => {
            dataSource.push({ value: item.value, label: item.value });
          })
        }

      });
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_dw_rydm.list;
    }
    if (number) {
      return <Row>
        {dataSource.map((item, index) => (value === item.value ?
          <Col span={span || 6}>
            <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span>&nbsp;<span>{(parseInt(index) + 1).toString() + ". "}{item.label}</span>
          </Col>
          :
          <Col span={span || 6}>
            <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px' }}>&nbsp;</span>&nbsp;<span>{(parseInt(index) + 1).toString() + ". "}{item.label}</span>
          </Col>
        )
        )}
      </Row>
    }
    else {
      return <Row>
        {dataSource.map((item, index) => (value === item.value ?
          <Col span={span || 6}>
            <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px' }}><Icon type='check' style={{ fontSize: '12px' }}></Icon></span>&nbsp;<span>{item.label}</span>
          </Col>
          :
          <Col span={span || 6}>
            <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px' }}>&nbsp;</span>&nbsp;<span>{item.label}</span>
          </Col>
        )
        )}
      </Row>
    }
  },
  ViewGroupBorderEqEtbj: (store, type, key, value, number, span) => {//值相等判断,不做相似度匹配
    let dataSource = [];
    if (value === '' || value === undefined || value === null) {
      value = 'NULL';
    }
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          _sjzd[index].children.map(item => {
            dataSource.push({ value: item.value, label: item.value });
          })
        }

      });
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_dw_rydm.list;
    }
    if (number) {
      return <div>
        {dataSource.map((item, index) => (value === item.value ?
          <span> <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px', position: 'relative' }}><Icon type='check' style={{ fontSize: '12px', position: 'absolute', top: '0px', left: '-8px' }}></Icon></span>&nbsp;<span>{(parseInt(index) + 1).toString() + ". "}{item.label}</span></span>
          :
          <span> <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px' }}>&nbsp;</span>&nbsp;<span>{(parseInt(index) + 1).toString() + ". "}{item.label}</span></span>
        )
        )}
      </div>
    }
    else {
      return <Row>
        {dataSource.map((item, index) => (value === item.value ?
          <Col span={span || 6}>
            <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px', position: 'relative' }}><Icon type='check' style={{ fontSize: '12px', position: 'absolute', top: '0px', left: '-8px' }}></Icon></span>&nbsp;<span>{item.label}</span>
          </Col>
          :
          <Col span={span || 6}>
            <span style={{ border: 'solid 1px #504e4e', display: 'inline-block', width: '17px', height: '16px', textAlign: 'center', lineHeight: '12px' }}>&nbsp;</span>&nbsp;<span>{item.label}</span>
          </Col>
        )
        )}
      </Row>
    }
  },
  stringShowBox: (value, border) => {
    return border ? value === '' || value === null || value === undefined ? <span style={{ border: 'solid 1px black', display: 'inline-block', width: '20px', height: '20px', lineHeight: '15px', textAlign: 'center', marginRight: '5px' }}>&nbsp;</span> : <span style={{ border: 'solid 1px black', display: 'inline-block', width: '20px', height: '20px', lineHeight: '15px', textAlign: 'center', marginRight: '5px' }}>{value}</span> : value === '' || value === null || value === undefined ? <span style={{ display: 'inline-block', width: '25px', textAlign: 'center', marginRight: '5px' }}>&nbsp;</span> : <span style={{ display: 'inline-block', width: '25px', textAlign: 'center', marginRight: '5px' }}>{value}</span>;
  },
  stringShowBoxSmall: (value, border) => {
    return border ? value === '' || value === null || value === undefined ? <span style={{ border: 'solid 1px black', display: 'inline-block', width: '16px', height: '16px', lineHeight: '10px', textAlign: 'center', marginRight: '5px' }}>&nbsp;</span> : <span style={{ border: 'solid 1px black', display: 'inline-block', width: '20px', height: '20px', lineHeight: '15px', textAlign: 'center', marginRight: '5px' }}>{value}</span> : value === '' || value === null || value === undefined ? <span style={{ display: 'inline-block', width: '25px', textAlign: 'center', marginRight: '5px' }}>&nbsp;</span> : <span style={{ display: 'inline-block', width: '25px', textAlign: 'center', marginRight: '5px' }}>{value}</span>;
  },
  xzdqDataSource: (store, xq, xzjb) => {
    const ObjUser = store.objUser;
    let data = [];
    if (xq === true) {
      let _xqdata = sessionStorage.getItem('xzdq_xq_data');
      if (_xqdata !== null && _xqdata !== '' && _xqdata !== undefined) {
        data = JSON.parse(_xqdata);
      }
      else {
        const _czyjb = xzjb !== undefined && xzjb !== null && xzjb !== '' ? parseInt(xzjb) : parseInt(ObjUser.czyjb);
        const xzdqData = JSON.parse(JSON.stringify(store.Dictionaries.dm_xtgl_xzdq.list));
        xzdqData.map(i1 => {
          let _xzjb = parseInt(i1.xzjb);
          if (_czyjb >= _xzjb) {
            i1.disabled = true;
          }
          if (i1.disabled && i1.children && _czyjb > _xzjb) {
            i1.children.map(i2 => {
              let _xzjb = parseInt(i2.xzjb);
              if (_czyjb >= _xzjb) {
                i2.disabled = true;
              }
              if (i2.disabled && i2.children && _czyjb > _xzjb) {
                i2.children.map(i3 => {
                  let _xzjb = parseInt(i3.xzjb);
                  if (_czyjb >= _xzjb) {
                    i3.disabled = true;
                  }
                  if (i3.disabled && i3.children && _czyjb > _xzjb) {
                    i3.children.map(i4 => {
                      let _xzjb = parseInt(i4.xzjb);
                      if (_czyjb >= _xzjb) {
                        i4.disabled = true;
                      }
                      if (i4.disabled && i4.children && _czyjb > _xzjb) {
                        i4.children.map(i5 => {
                          let _xzjb = parseInt(i5.xzjb);
                          if (_czyjb >= _xzjb) {
                            i5.disabled = true;
                          }
                        })
                      }
                    })
                  }
                })
              }
            })
          }
          data.push(i1);
        })
        sessionStorage.setItem('xzdq_xq_data', JSON.stringify(data))
      }
    }
    else {
      data = store.Dictionaries.dm_xtgl_xzdq.list;
    }
    return data;
  },
  sjzdDataSource: (store, type, key) => {
    let dataSource = [];
    if (type === 'dm_xtgl_sjzd') {
      const _sjzd = store.Dictionaries.dm_xtgl_sjzd.list;
      _sjzd.map((obj, index) => {
        if (obj.keyValue === key) {
          dataSource = _sjzd[index].children;
        }
      });
    }
    else if (type === 'dm_xtgl_dwdm') {
      dataSource = store.Dictionaries.dm_xtgl_dwdm.list;
    }
    else if (type === 'dm_xtgl_dw_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_dw_rydm.list;
    }
    else if (type === 'dm_xtgl_ksdm') {
      dataSource = store.Dictionaries.dm_xtgl_ksdm.list;
    }
    else if (type === 'dm_xtgl_ks_rydm') {
      dataSource = store.Dictionaries.dm_xtgl_ks_rydm.list;
    }
    else if (type === 'dm_xtgl_glmk') {
      dataSource = store.Dictionaries.dm_xtgl_glmk.list;
    }
    else if (type === 'init') {//store未传递的数据集


      dataSource = store;
    }
    return dataSource;
  },
  /**受控主键值处理**/
  formChange: (obj, type) => {
    let _param = {};
    try {
      if (type === 'input') {
        _param = SSAS.inputChange(obj.e);
      }
      else if (type === 'xzdq') {
        _param = SSAS.xzdqChange(obj.option, obj.value.length - 1);
      }
      else if (type === 'select') {
        _param = SSAS.selectChange(obj.value, obj.option);
      }
    }
    catch (e) {
      message.error(e);
    }
    return _param;
  },
  inputChange: (e) => {/**输入项改变**/
    let _par = {};
    _par[e.target.name] = e.target.value;
    return _par;
  },
  xzdqChange: (option, index) => {/**地区选择改变**/
    let _par = { dqid: '', dqfhmc: '', xzjb: '' };
    if (index > -1) {
      _par.dqid = option[index].value;
      _par.dqfhmc = option[index].label;
      _par.xzjb = option[index].xzjb;
    }
    return _par;
  },
  selectChange: (value, option) => {
    let _par = {};
    if (value !== '') {
      _par = option.props;
    }
    return _par;
  },
  propWindow: (par, method) => {/**propwindow**/
    PopWindow = info({
      title: par.title || '请刷卡',
      icon: par.icon || 'credit-card',
      closable: true,
      maskClosable: true,
      content: <Input placeholder={par.title || '请刷卡'} name='pubCardNumber' id='pubCardNumber' autoFocus={true} onPressEnter={e => SSAS.propEnter(e.target.value, method)} />,
      okText: '确定',
      destroyOnClose: true,
      onOk() {
        let _cardNum = document.getElementById('pubCardNumber').value;
        SSAS.propEnter(_cardNum, method);
      }
    });
    setTimeout(() => {
      document.getElementById('pubCardNumber').focus();
    }, 400);
  },
  propEnter: (_cardNum, method) => {
    if (_cardNum !== '' && _cardNum !== null && _cardNum !== undefined) {
      method(true, _cardNum);
      setTimeout(() => {
        PopWindow.destroy();
      }, 500);
    }
    else {
      message.error('输入内容不能为空');
    }
  },
  exportExcels: (fileName, list) => {
    // 新建工作谱
    const file = new File();
    // 新建表
    list.map(item => {
      const column = item.column;
      const dataSource = item.dataSource;
      const fileName = item.fileName;
      //#region 表格生成
      let sheet = file.addSheet(fileName);
      // 获取表头行数
      let depth = getDepth(column);
      // 获取表头的列数
      let columnNum = getColumns(column);
      // 新建表头行数
      let rowArr = [];
      for (let k = 0; k < depth; k++) {
        rowArr.push(sheet.addRow());
      }
      // 根据列数填充单元格
      rowArr.map(ele => {
        for (let j = 0; j < columnNum; j++) {
          let cell = ele.addCell();
          cell.value = j;
        }
      });
      // 初始化表头
      init(column, 0, 0);
      // 按顺序展平column
      let columnLineArr = [];
      columnLine(column);
      // 根据column,将dataSource里面的数据排序，并且转化为二维数组
      let dataSourceArr = [];
      dataSource.map(ele => {
        let dataTemp = [];
        columnLineArr.map(item => {
          dataTemp.push({
            [item.dataIndex]: ele[item.dataIndex],
            value: ele[item.dataIndex],
          });
        });
        dataSourceArr.push(dataTemp);
      });
      // debugger;
      var dark = 'ff7e6a54';
      //设置单元格样式
      const style = new xlsx.Style();
      style.font.size = 10;
      style.align.h = 'center';
      style.align.v = 'center';
      style.border.top = 'thin';
      style.border.topColor = dark;
      style.border.left = 'thin';
      style.border.leftColor = dark;
      style.border.bottom = 'thin';
      style.border.bottomColor = dark;
      style.border.right = 'thin';
      style.border.rightColor = dark;

      // 绘画表格数据
      dataSourceArr.forEach((item, index) => {
        //根据数据,创建对应个数的行
        let row = sheet.addRow();
        row.setHeightCM(0.8);
        //创建对应个数的单元格
        item.map(ele => {
          let cell = row.addCell();
          cell.style = style;
          if (ele.hasOwnProperty('num')) {
            cell.value = index + 1;
          } else {
            if (typeof (ele.value) === 'boolean') {
              cell.value = ele.value ? '是' : '否'
            }
            else if (isNaN(ele.value) && !isNaN(Date.parse(ele.value))) {
              if (ele.value.indexOf('年') > -1 || ele.value.indexOf('-') > -1) {
                cell.value = ele.value;
              }
              else if (ele.value.indexOf('T00:') > -1) {
                cell.value = SSAS.pubDefaultValue(ele.value, 'date', 'YYYY年MM月DD日');
              }
              else {
                cell.value = SSAS.pubDefaultValue(ele.value, 'datetime', 'YYYY年MM月DD日 HH时Mmm分');
              }
            }
            else {
              cell.value = ele.value;
            }
          }
        });
      });
      //设置每列的宽度


      for (var i = 0; i < 4; i++) {
        sheet.col(i).width = 10;
      }

      // 按顺序展平column
      function columnLine(column) {
        column.map(ele => {
          if (ele.children === undefined || ele.children.length === 0) {
            columnLineArr.push(ele);
          } else {
            columnLine(ele.children);
          }
        });
      }
      // 初始化表头


      function init(column, rowIndex, columnIndex) {
        column.map((item, index) => {
          let hCell = sheet.cell(rowIndex, columnIndex);
          hCell.style.border.top = 'thin';
          hCell.style.border.topColor = dark;
          hCell.style.border.left = 'thin';
          hCell.style.border.leftColor = dark;
          hCell.style.border.bottom = 'thin';
          hCell.style.border.bottomColor = dark;
          hCell.style.border.right = 'thin';
          hCell.style.border.rightColor = dark;
          hCell.style.align.h = 'center';
          hCell.style.align.v = 'center';
          hCell.style.font.size = 10;
          // 如果没有子元素, 撑满列
          if (item.title === '操作') {
            hCell.value = '';
            return;
          } else if (item.children === undefined || item.children.length === 0) {
            // 第一行加一个单元格
            hCell.value = item.title;
            hCell.vMerge = depth - rowIndex - 1;
            columnIndex++;
            // rowIndex++
          } else {
            let childrenNum = 0;
            function getColumns(arr) {
              arr.map(ele => {
                if (ele.children) {
                  getColumns(ele.children);
                } else {
                  childrenNum++;
                }
              });
            }
            getColumns(item.children);
            hCell.hMerge = childrenNum - 1;
            hCell.value = item.title;
            let rowCopy = rowIndex;
            rowCopy++;
            init(item.children, rowCopy, columnIndex);
            // 下次单元格起点
            columnIndex = columnIndex + childrenNum;
          }
        });
      }
      // 获取表头rows
      function getDepth(arr) {
        const eleDepths = [];
        arr.forEach(ele => {
          let depth = 0;
          if (Array.isArray(ele.children)) {
            depth = getDepth(ele.children);
          }
          eleDepths.push(depth);
        });
        return 1 + max(eleDepths);
      }

      function max(arr) {
        return arr.reduce((accu, curr) => {
          if (curr > accu) return curr;
          return accu;
        });
      }
      // 计算表头列数
      function getColumns(arr) {
        let columnNum = 0;
        arr.map(ele => {
          if (ele.children) {
            getColumns(ele.children);
          } else {
            columnNum++;
          }
        });
        return columnNum;
      }
      //#endregion
    });

    file.saveAs('blob').then(function (content) {
      const _name = fileName.indexOf('.xlsx') > -1 ? fileName : fileName + '.xlsx';
      saveAs(content, moment().format('YYYY年MM月DD日') + _name);
    });
  },
  exportExcel: (column, dataSource, fileName = '智慧妇幼导出表格') => {/**导出excle**/
    // 新建工作谱


    const file = new File();
    // 新建表


    let sheet = file.addSheet(fileName);
    // 获取表头行数
    let depth = getDepth(column);
    // 获取表头的列数


    let columnNum = getColumns(column);
    // 新建表头行数
    let rowArr = [];
    for (let k = 0; k < depth; k++) {
      rowArr.push(sheet.addRow());
    }
    // 根据列数填充单元格


    rowArr.map(ele => {
      for (let j = 0; j < columnNum; j++) {
        let cell = ele.addCell();
        cell.value = j;
      }
    });
    // 初始化表头


    init(column, 0, 0);
    // 按顺序展平column
    let columnLineArr = [];
    columnLine(column);
    // 根据column,将dataSource里面的数据排序，并且转化为二维数组


    let dataSourceArr = [];
    dataSource.map(ele => {
      let dataTemp = [];
      columnLineArr.map(item => {
        dataTemp.push({
          [item.dataIndex]: ele[item.dataIndex],
          value: ele[item.dataIndex],
        });
      });
      dataSourceArr.push(dataTemp);
    });
    // debugger;
    var dark = 'ff7e6a54';
    //设置单元格样式
    const style = new xlsx.Style();
    style.font.size = 10;
    style.align.h = 'center';
    style.align.v = 'center';
    style.border.top = 'thin';
    style.border.topColor = dark;
    style.border.left = 'thin';
    style.border.leftColor = dark;
    style.border.bottom = 'thin';
    style.border.bottomColor = dark;
    style.border.right = 'thin';
    style.border.rightColor = dark;
    // 绘画表格数据
    dataSourceArr.forEach((item, index) => {
      //根据数据,创建对应个数的行
      let row = sheet.addRow();
      row.setHeightCM(0.8);
      //创建对应个数的单元格
      item.map(ele => {
        let cell = row.addCell();

        cell.style = style;
        if (ele.hasOwnProperty('num')) {
          cell.value = index + 1;
        } else {
          if (typeof (ele.value) === 'boolean') {
            cell.value = ele.value ? '是' : '否'
          }
          else if (isNaN(ele.value) && !isNaN(Date.parse(ele.value))) {
            if (ele.value.indexOf('年') > -1 || ele.value.indexOf('-') > -1) {
              cell.value = ele.value;
            }
            else if (ele.value.indexOf('T00:') > -1) {
              cell.value = SSAS.pubDefaultValue(ele.value, 'date', 'YYYY年MM月DD日');
            }
            else {
              cell.value = SSAS.pubDefaultValue(ele.value, 'datetime', 'YYYY年MM月DD日 HH时Mmm分');
            }
          }
          else {
            cell.value = ele.value;
          }
        }
      });
    });
    //设置每列的宽度


    for (var i = 0; i < 4; i++) {
      sheet.col(i).width = 10;
    }
    file.saveAs('blob').then(function (content) {
      const _name = fileName.indexOf('.xlsx') > -1 ? fileName : fileName + '.xlsx';
      saveAs(content, moment().format('YYYY年MM月DD日') + _name);
    });

    // 按顺序展平column
    function columnLine(column) {
      column.map(ele => {
        if (ele.children === undefined || ele.children.length === 0) {
          columnLineArr.push(ele);
        } else {
          columnLine(ele.children);
        }
      });
    }
    // 初始化表头


    function init(column, rowIndex, columnIndex) {
      column.map((item, index) => {
        let hCell = sheet.cell(rowIndex, columnIndex);
        hCell.style.border.top = 'thin';
        hCell.style.border.topColor = dark;
        hCell.style.border.left = 'thin';
        hCell.style.border.leftColor = dark;
        hCell.style.border.bottom = 'thin';
        hCell.style.border.bottomColor = dark;
        hCell.style.border.right = 'thin';
        hCell.style.border.rightColor = dark;
        hCell.style.align.h = 'center';
        hCell.style.align.v = 'center';
        hCell.style.font.size = 10;

        // 如果没有子元素, 撑满列
        if (item.title === '操作') {
          hCell.value = '';
          return;
        } else if (item.children === undefined || item.children.length === 0) {
          // 第一行加一个单元格
          hCell.value = item.title;
          hCell.vMerge = depth - rowIndex - 1;
          columnIndex++;
          // rowIndex++
        } else {
          let childrenNum = 0;
          function getColumns(arr) {
            arr.map(ele => {
              if (ele.children) {
                getColumns(ele.children);
              } else {
                childrenNum++;
              }
            });
          }
          getColumns(item.children);
          hCell.hMerge = childrenNum - 1;
          hCell.value = item.title;
          let rowCopy = rowIndex;
          rowCopy++;
          init(item.children, rowCopy, columnIndex);
          // 下次单元格起点


          columnIndex = columnIndex + childrenNum;
        }
      });
    }
    // 获取表头rows
    function getDepth(arr) {
      const eleDepths = [];
      arr.forEach(ele => {
        let depth = 0;
        if (Array.isArray(ele.children)) {
          depth = getDepth(ele.children);
        }
        eleDepths.push(depth);
      });
      return 1 + max(eleDepths);
    }

    function max(arr) {
      return arr.reduce((accu, curr) => {
        if (curr > accu) return curr;
        return accu;
      });
    }
    // 计算表头列数
    function getColumns(arr) {
      let columnNum = 0;
      arr.map(ele => {
        if (ele.children) {
          getColumns(ele.children);
        } else {
          columnNum++;
        }
      });
      return columnNum;
    }
  },
  /**公用方法**/
  XzdqFilter: {
    limit: 10,
    filter: (inputValue, path) => {
      return path.some(option => option.filterValue ? option.filterValue.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 : option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    }
  },
  pubSfzOnChange: (sfz_hm, method) => {
    //返回能直接通过身份证号码获取到的信息


    if (sfz_hm.length > 13) {
      //区县行政区划代码
      const _dqid = sfz_hm.substring(0, 6);
      const _arrDqid = [sfz_hm.substring(0, 2) + '0000', sfz_hm.substring(0, 4) + '00', sfz_hm.substring(0, 6)];
      let _csrq = moment(sfz_hm.substring(6, 14)).format('YYYY-MM-DD');
      method(true, { dqid: _dqid, arrDqid: _arrDqid, csrq: _csrq });
    }
    else {
      method(false, {});
    }
  },
  pubDateOnChange: (r1, r2, type, method) => {//两日期关系处理


    let _result = {};
    if (r1 != undefined && r2 != undefined) {
      try {
        let rq1 = moment(r1).format('YYYY-MM-DD');
        let rq2 = moment(r2).format('YYYY-MM-DD');
        if (rq1.length === 10 && rq2.length === 10) {
          if (type === 'nl') {
            /**计算年龄**/
            let date1 = new Date(rq1); //开始时间


            let date2 = new Date(rq2);//结束时间
            let date3 = date2.getTime() - date1.getTime(); //时间差秒
            //计算出相差天数


            let days = Math.floor(date3 / (24 * 3600 * 1000));
            let _age_year = days / 365; //年


            let _d1 = days - (365 * _age_year.toFixed(0));
            let _age_month = _d1 / 30; //月


            let _age_day = days - _age_month * 365 - _age_month * 30;
            _result = { age_year: _age_year.toFixed(0), age_month: _age_month.toFixed(0), age_day: _age_day.toFixed(0) };
          }
          else if (type === 'yz') {
            /**计算孕周**/
            let date1 = new Date(rq1); //开始时间


            let date2 = new Date();
            if (rq2 != '' && rq2 != null) {
              date2 = new Date(rq2);
            }
            //结束时间
            let date3 = date2.getTime() - date1.getTime(); //时间差秒
            //计算出相差天数


            let days = Math.floor(date3 / (24 * 3600 * 1000));
            let _number = days / 7; //周


            let _intNumber = _number.toString().split('.')[0];
            let _yzNumber = parseInt(_intNumber); //周


            let _yzNumber2 = days - _yzNumber.toFixed(0) * 7;
            _result = { yz: _yzNumber2 === 0 ? _yzNumber.toFixed(0).toString() : _yzNumber.toFixed(0).toString() + '+' + _yzNumber2.toFixed(0).toString(), _yzNumber2: _yzNumber };
          }
          else if (type === 'day') {
            let date1 = new Date(rq1); //开始时间


            let date2 = new Date(rq2);//结束时间
            let date3 = date2.getTime() - date1.getTime(); //时间差秒
            //计算出相差天数


            let days = Math.floor(date3 / (24 * 3600 * 1000));
            _result = { day: days }
          }
          else if (type === 'ycq') {
            /**计算预产期**/
            let _ycq = moment(rq1).add(+280, 'day').format('YYYY-MM-DD');
            _result = { ycq: _ycq };
          }
          if (method !== undefined) {
            method(true, _result);
          }
        }
        else {
          if (method !== undefined) {
            method(false, _result);
          }
        }
      }
      catch (e) {
        message.error(e);
      }
    }
    else {
      if (method != undefined) {
        method(false, _result);
      }
    }
  },
  pubDateSum: (rq, day, format) => {//日期计算,增加/减少天数
    if (format) {
      return moment(rq).add(day, 'day').format('YYYY-MM-DD');
    }
    else {
      return moment(rq).add(day, 'day')
    }
  },
  pubStrSpliteToJson: (str, slt, sltc) => {//str格式 key|label/key|lable 返回[{key: "0117090115571", label: "外翻足"}]
    let _result = [];
    if (str !== null && str !== undefined && str !== '') {
      let _data = str.split(slt);
      _data.map(obj => {
        _result.push({ key: obj.split(sltc)[0], label: obj.split(sltc)[1] });
      });
    }
    return _result;
  },
  pubStrSpliteToStr: (str, slt, sltc) => {//str格式 key|label/key|lable 返回label
    let _result = '';
    if (str !== null && str !== undefined && str !== '') {
      let _data = str.split(slt);
      _data.map(obj => {
        _result += obj.split(sltc)[1] + '/';
      });
    }
    if (_result !== '') {
      _result = _result.substring(0, _result.length - 1);
    }
    return _result;
  },
  pubJsonSpliteToStr: (parame, slt) => {//json格式 [{key:'',label:''}] 返回字符串/
    let _result = '';
    if (parame !== null && parame !== undefined) {
      parame.map(obj => {
        _result += obj.label + slt;
      });
    }
    if (_result !== '') {
      _result = _result.substring(0, _result.length - 1);
    }
    return _result;
  },
  pubDefaultValue: (value, type, unit, dateNotFomat) => {//判断默认值


    let _result = '';
    if (dateNotFomat === undefined && dateNotFomat === null && typeof (unit) === 'boolean') {
      unit = null;
      dateNotFomat = unit;
    }
    if (value !== undefined && value !== '' && value !== null) {
      switch (type) {
        case 'byte':
          _result = parseInt(value) === 255 ? null : value
          break;
          //lyh20240409增加
        case 'decimal':
          _result = parseInt(value) === -18400628 ? null : value
          break;
        case 'date':
          if (dateNotFomat !== undefined && dateNotFomat !== null) {
            _result = value === '1840-06-28T00:00:00' || value === '1900-01-01T00:00:00' ? null : moment(value);
          }
          else {
            var _format = unit !== null && unit !== undefined && unit !== '' ? unit : 'YYYY年MM月DD日';
            _result = value === '1840-06-28T00:00:00' || value === '1900-01-01T00:00:00' ? null : moment(value).format(_format);
            unit = null;
          }
          break;
        case 'datetime':
          if (dateNotFomat !== undefined && dateNotFomat !== null) {
            _result = value === '1840-06-28T00:00:00' || value === '1900-01-01T00:00:00' ? null : moment(value);
          }
          else {
            let _format = 'YY-MM-DD HH:MM';
            if (unit !== '' && unit !== null && unit !== undefined) {
              _format = unit;
            }
            unit = null;
            _result = value === '1840-06-28T00:00:00' || value === '1900-01-01T00:00:00' ? null : moment(value).format(_format);
          }
          break;
        case 'number':
          _result = parseInt(value) < 0 ? null : value
          break;
        default:
          _result = value === null || value === undefined || value === 'null' || value === 'undefined' ? '' : value;
          break;
      }
    }
    if (unit !== null && unit !== undefined && _result !== null && _result !== '') {
      _result = _result + unit;
    }
    return _result;
  },
  textareaValue: (value, slt) => {//字符串处理为多行文本
    let _result = '';
    if (value !== '' && value !== undefined && value !== null) {
      _result = value.replace(slt, '\n').replace(slt, '\n').replace(slt, '\n').replace(slt, '\n').replace(slt, '\n').replace(slt, '\n').replace(slt, '\n').replace(slt, '\n').replace(slt, '\n').replace(slt, '\n');
    }
    return _result;
  },
  textareaStr: (value, slt) => {//字符串处理为多行文本
    let _result = '';
    if (value !== '' && value !== undefined && value !== null) {
      _result = value.replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '').replace(slt, '');
    }
    return _result;
  },
  bmiCalc: (sc, tz) => {//bmi计算
    let _bmi = '';
    if (sc !== '' && tz !== '' && sc !== null && tz !== null && sc !== undefined && tz !== undefined) {
      sc = sc / 100;
      let _scp = sc * sc;
      _bmi = tz / _scp;
      _bmi = _bmi.toFixed(2);
    }
    return _bmi;
  },
  pubXtszDqz: (store, dm) => {//获取系统设置当前值


    let _dqz = '';
    if (store.Dictionaries.dm_xtgl_xtsz.list !== null && store.Dictionaries.dm_xtgl_xtsz.list !== undefined) {
      if (store.Dictionaries.dm_xtgl_xtsz.list.length > 0) {
        const list = store.Dictionaries.dm_xtgl_xtsz.list[0];
        list.map(item => {
          if (item.dm === dm) {
            _dqz = item.dqz;
            return;
          }
        });
      }
    }
    return _dqz;
  },
  pgbZdpg: (type, number, rq, fn) => {//评估表自动评估


    if (type === 'bi') {
      //#region 自理能力评估
      const _pgdj = number === 100 ? '无需依赖' : number > 60 && number < 100 ? '轻度依赖' : number > 40 && number < 61 ? '中度依赖' : '重度依赖';
      const _pgrq_xc = number > 60 ? moment(rq).add('days', 7) : moment(rq).add('days', 3);
      fn({ bi_pgzf: number, bi_pgdj: _pgdj, bi_pgrq_xc: _pgrq_xc });
      //#endregion
    }
    else if (type === 'dd') {
      //#region 跌倒评估


      const _pgdj = number === 1 ? '较高风险' : number > 1 ? '高风险' : '低风险';
      const _pgrq_xc = moment(rq).add('days', 7);
      fn({ dd_pgzf: number, dd_pgdj: _pgdj, dd_pgrq_xc: _pgrq_xc });
      //#endregion
    }
    else if (type === 'yc') {
      //#region 压疮评估
      const _pgdj = number <= 9 ? '极高风险' : number > 9 && number < 13 ? '高风险' : number > 12 && number < 15 ? '高较风险' : '低风险';
      const _pgrq_xc = number <= 9 ? moment(rq).add('days', 2) : number > 9 && number < 13 ? moment(rq).add('days', 3) : moment(rq).add('days', 7);
      fn({ yc_pgzf: number, yc_pgdj: _pgdj, yc_pgrq_xc: _pgrq_xc });
      //#endregion
    }
    else if (type === 'tt') {
      //#region 疼痛
      const _pgdj = number === 0 ? '无痛' : number > 0 && number < 4 ? '轻度疼痛' : number > 3 && number < 7 ? '中度疼痛' : '重度疼痛';
      const _pgrq_xc = number === 0 ? moment(rq).add('days', 1) : number > 0 && number < 4 ? moment(rq).add('days', 1) : number > 3 && number < 7 ? moment(rq).add('hours', 4) : moment(rq).add('hours', 2);
      fn({ tt_pgzf: number, tt_pgdj: _pgdj, tt_pgrq_xc: _pgrq_xc });
      //#endregion
    }
    else if (type === 'vte') {
      //#region vte评估
      const _pgdj = number >= 5 ? '极高风险' : number > 2 && number < 5 ? '高风险' : number === 2 ? '高较风险' : '低风险';
      const _pgrq_xc = number > 2 ? moment(rq).add('days', 1) : number === 2 ? moment(rq).add('days', 3) : moment(rq).add('days', 7);
      fn({ vte_pgzf: number, vte_pgdj: _pgdj, vte_pgrq_xc: _pgrq_xc });
      //#endregion
    }
    else if (type === 'dg') {
      //#region 导管评估
      const _pgdj = number <= 10 ? 'I度风险' : number > 10 && number < 15 ? 'II度风险' : number >= 15 ? 'III度风险' : '无';
      const _pgrq_xc = number <= 10 ? moment(rq).add('days', 7) : number > 10 && number < 15 ? moment(rq).add('days', 3) : number >= 15 ? moment(rq).add('days', 1) : moment(rq).add('days', 7);
      fn({ dg_pgzf: number, dg_pgdj: _pgdj, dg_pgrq_xc: _pgrq_xc });
      //#endregion
    }
  },
  pgbFxys: (type, pgjb) => {
    let _color = '';
    if (type === 'sj_ycf_ck_pgb_bi') {
      _color = pgjb === '中度依赖' ? 'warning' : pgjb === '重度依赖' ? 'danger' : '';
    }
    else if (type === 'sj_ycf_ck_pgb_dd') {
      _color = pgjb === '较高风险' ? 'warning' : pgjb === '高风险' || pgjb === '极高风险' ? 'danger' : '';
    }
    else if (type === 'sj_ycf_ck_pgb_yc') {
      _color = pgjb === '较高风险' ? 'warning' : pgjb === '高风险' || pgjb === '极高风险' ? 'danger' : '';
    }
    else if (type === 'sj_ycf_ck_pgb_tt') {
      _color = pgjb === '中度疼痛' ? 'warning' : pgjb === '重度疼痛' || pgjb === '极高风险' ? 'danger' : '';
    }
    else if (type === 'sj_ycf_ck_pgb_vte') {
      _color = pgjb === '较高风险' ? 'warning' : pgjb === '高风险' || pgjb === '极高风险' ? 'danger' : '';
    }
    else if (type === 'sj_ycf_ck_pgb_dg') {
      _color = pgjb === 'I度风险' ? 'warning' : pgjb === 'II度风险' || pgjb === 'III度风险' ? 'danger' : '';
    }
    return _color;
  },
  pubXqdwLoad: (parame, fn) => {//parame:{dqid:xxx,...x,...x,},获取选择辖区内的机构
    request({
      url: 'api/Xtgl/xqdwLoad',
      method: 'post',
      data: parame
    }).then(function (res) {
      if (res !== null && res !== undefined) {
        fn(res.data);
      }
      else {
        if (fn !== null && fn !== undefined && fn !== '') {
          fn([]);
        }
      }
    });
  },
  pubGldwLoad: (parame, fn) => {//parame:{dqid:xxx,pqyylb:xx},匹配辖区内的指定类型的管理机构


    request({
      url: 'api/Xtgl/gldwLoad',
      method: 'post',
      data: parame
    }).then(function (res) {
      if (res !== null && res !== undefined) {
        fn(res.data);
      }
      else {
        if (fn !== null && fn !== undefined && fn !== '') {
          fn([]);
        }
      }
    });
  },
  pubDwLoadByCode: (parame, fn) => {//parame:{pybm:xxx,pqyylb:xx},更具机构代码匹配机构和机构所在地区信息


    request({
      url: 'api/Xtgl/dwdmLoadByCode',
      method: 'post',
      data: parame
    }).then(function (res) {
      if (res !== null && res !== undefined) {
        fn(res.data);
      }
      else {
        if (fn !== null && fn !== undefined && fn !== '') {
          fn([]);
        }
      }
    });
  },
  pubDwryLoad: (parame, fn) => {//parame:{dqid:xxx,...x,...x,},获取选择的机构下的人员


    request({
      url: 'api/Xtgl/dwryLoad',
      method: 'post',
      data: parame
    }).then(function (res) {
      if (res !== null && res !== undefined) {
        fn(res.data);
      }
      else {
        if (fn !== null && fn !== undefined && fn !== '') {
          fn([]);
        }
      }
    });
    //dwryLoad
  },
  urlToBase64: (url) => {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var fileReader = new FileReader()
          fileReader.onloadend = function (e) {
            var result = e.target.result
            resolve(result)
          }
          fileReader.readAsDataURL(blob)
        }
      }
      xhr.onerror = function () {
        reject()
      }
      xhr.send()
    })
  },
  SpeechSynthesis: {
    //#region 语音播报
    Init: (autoPlay, msg) => {
      if (!('speechSynthesis' in window)) {
        throw alert("对不起，您的设备不支持语音播报")
      }
      else {
        let voices = [];
        let _langObj = null;
        voices = window.speechSynthesis.getVoices();
        for (var i = 0; i < voices.length; i++) {
          if (voices[i].default) {
            _langObj = voices[i];
          }
        }
        if (_langObj === null) {
          _langObj = voices[0];
        }
        if (autoPlay) {
          SSAS.SpeechSynthesis.Play(_langObj, msg);
        }
      }
    },
    Play: (_langObj, msg) => {
      SSAS.SpeechSynthesis.Cancel();
      let to_speak = window.speechSynthesis;
      to_speak = new SpeechSynthesisUtterance(msg);
      //to_speak.rate = 1.4;// 设置播放语速，范围：0.1 - 10之间
      to_speak.voice = _langObj;
      window.speechSynthesis.speak(to_speak);
    },
    Cancel: () => {
      window.speechSynthesis.cancel();
    }
    //#endregion
  },
  //格式化时间"yyyy-hh-dd"
  formatDate(date) {
    const dateFormat = new Date(date)
    const resDate = dateFormat.getFullYear() + '-' + this.p((dateFormat.getMonth() + 1)) + '-' + this.p(dateFormat.getDate())
    return resDate
  },
  p(s) {
    return s < 10 ? '0' + s : s
  },
  //根据身份证号码计算出生日期、年龄

  getBirthdateAndAgeByIdCardNum(idCardNum) {
    const year = idCardNum.substring(6, 10)
    const month = idCardNum.substring(10, 12)
    const day = idCardNum.substring(12, 14)
    const birthdate = year + "-" + month + "-" + day
    const birthDay = new Date(birthdate)
    const nowDate = new Date()
    const date1 = Date.parse(birthDay)
    const date2 = Date.parse(nowDate)
    const intervalDay = Math.ceil((date2 - date1) / (60 * 60 * 1000 * 24))
    const age = Math.floor(intervalDay / 365)
    const result = { age: age, birthDate: birthdate }
    return result
  }

}
export default SSAS;
